import React from "react";
import { Link } from "react-router-dom";
import { InstagramLogo, FacebookLogo, LinkedinLogo } from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t, r, lang } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-[#09090b] pt-24 pb-10 border-t border-white/10" data-testid="site-footer">
      <div className="container-x grid lg:grid-cols-4 gap-12">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-8 rounded-full border border-[#C5A059] flex items-center justify-center">
              <span className="font-serif text-[#C5A059] text-lg leading-none">A</span>
            </span>
            <div className="leading-tight">
              <div className="font-serif text-base tracking-wide">Hotel Alpi Resort</div>
              <div className="overline text-[10px]">Torino · Italia</div>
            </div>
          </div>
          <p className="text-white/60 max-w-md text-base leading-relaxed">{t.footer.tagline}</p>
          <div className="flex items-center gap-4 mt-8">
            <a href="https://instagram.com/" target="_blank" rel="noreferrer" className="text-white/60 hover:text-[#C5A059] transition" data-testid="social-instagram"><InstagramLogo size={22} /></a>
            <a href="https://facebook.com/" target="_blank" rel="noreferrer" className="text-white/60 hover:text-[#C5A059] transition" data-testid="social-facebook"><FacebookLogo size={22} /></a>
            <a href="https://linkedin.com/" target="_blank" rel="noreferrer" className="text-white/60 hover:text-[#C5A059] transition" data-testid="social-linkedin"><LinkedinLogo size={22} /></a>
          </div>
        </div>

        <div>
          <div className="overline mb-5">{t.footer.pages}</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to={r.rooms} className="hover:text-[#C5A059]">{t.nav.rooms}</Link></li>
            <li><Link to={r.experience} className="hover:text-[#C5A059]">{t.nav.experience}</Link></li>
            <li><Link to={r.offers} className="hover:text-[#C5A059]">{t.nav.offers}</Link></li>
            <li><Link to={r.services} className="hover:text-[#C5A059]">{t.nav.services}</Link></li>
            <li><Link to={r.about} className="hover:text-[#C5A059]">{t.nav.about}</Link></li>
            <li><Link to={r.contact} className="hover:text-[#C5A059]">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-5">{t.footer.info}</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li>Via Alfonso Bonafous, 5</li>
            <li>10123 Torino, Italia</li>
            <li>+39 011 123 4567</li>
            <li>info@hotelalpiresort.it</li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-20 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-xs text-white/40">
          © {year} Hotel Alpi Resort · {t.footer.rights}
        </div>
        <div className="text-xs text-white/40 flex gap-6">
          <a href="#" className="hover:text-[#C5A059]">{t.footer.privacy}</a>
          <a href="#" className="hover:text-[#C5A059]">{t.footer.legal}</a>
          <span className="uppercase tracking-[0.25em] text-[#C5A059]/80">{lang}</span>
        </div>
      </div>
    </footer>
  );
}
